import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpClient } from "@coworker/http-client";

async function updateUserLastActiveAtByUid(uid: string) {
  return await httpClient.core.put(`/users/${uid}/last-active-at`, {
    body: {},
  });
}

export const useUpdateUserLastActiveAt = (uid: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => updateUserLastActiveAtByUid(uid),
    onSuccess: () => {
      return queryClient.invalidateQueries({
        queryKey: ["user", uid],
      });
    },
  });
};
